/** @jsx jsx */
import { css, jsx } from "@emotion/core"
import { themeColors } from "../../../Components/EOSThemeProvider"

/**
 * Prices shown to customers are always net - VAT is only ever added on the order/quote totals.
 * UK and Ireland are the only operating regions, so this sits alongside every product price.
 */
export function ExclVatLabel({
  block,
  align = "left",
  size = 12,
}: {
  /** Render on its own line underneath the price rather than inline after it */
  block?: boolean
  align?: "left" | "right"
  size?: number
}) {
  return (
    <span
      css={css`
        display: ${block ? "block" : "inline"};
        color: ${themeColors.grey};
        font-size: ${size}px;
        font-weight: 400;
        line-height: 1.4;
        text-align: ${align};
        white-space: nowrap;
      `}
    >
      excl. VAT
    </span>
  )
}
